/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRosreestrIcon24Solid = forwardRef('GovKoRosreestrIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12.25 8.25V1.035A8.002 8.002 0 0 0 5.035 8.25h7.215Z" }),
        React.createElement("path", { d: "M13.75 8.25V1.035a8.002 8.002 0 0 1 7.215 7.215H13.75Z" }),
        React.createElement("path", { d: "M13.75 9.75h7.215a8.002 8.002 0 0 1-7.215 7.215V9.75Z" }),
        React.createElement("path", { d: "M12.07 18.25H5v4.15a.6.6 0 0 0 .6.6h.6a6.002 6.002 0 0 0 5.87-4.75Z" }),
        React.createElement("path", { d: "M12.25 9.75v7H5v-7h7.25Z" })));
});
